import { connect } from 'react-redux';
import Homepage from './HomePage';

function mapStateToProps({ config, geoIp, marketing, offers }) {
  return {
    country: geoIp.geoIpInfo.country,
    offers: Object.values(offers.byId).map(offer => ({
      title: offer.details,
      logo: `//images.gasbuddy.io/autox100/${offer.partner.image_url}`,
      tags: offer.tags,
    })),
    payNgHost: config.payNgHost,
    platformTotals: marketing.platformTotals,
    savedByUser: marketing.savedByUser,
  };
}

export default connect(mapStateToProps)(Homepage);
